<template>
  <div>
    <div class="vx-col w-full mt-3">
      <ul class="heading-ul mb-2">
        <li>
          <div class="vx-row items-center gap-2">
            <feather-icon
              @click="cancel"
              icon="ArrowLeftIcon"
              class="cursor-pointer"
              svgClasses="text-dark"
            />
            <h4>{{ $t("setup.label.addQuestionSet") }}</h4>
          </div>
        </li>
      </ul>
    </div>

    <ValidationObserver ref="observer">
      <div class="vx-row">
        <vx-card card-border class="w-full">
          <vs-switch color="success" class="mb-3" v-model="isSelfCare">
            <span slot="on">Selfcare</span>
            <span slot="off">CRM</span>
          </vs-switch>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("setup.label.Category") }}
                  <span class="required">*</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.Category')"
                >
                  <v-select
                    label="mCodeValue"
                    :options="ticketTemplates.problemsDatas || []"
                    :placeholder="$t('customers.label.SelectCategory')"
                    :reduce="(mCodeValue) => mCodeValue.id"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="category"
                    @input="getSubCategory"
                    class="min-w-200 w-full mb-2"
                  >
                    <template v-slot:option="option">{{
                      option.mCodeValue
                    }}</template>
                  </v-select>
                  <span class="validate-error text-danger">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-col w-full lg:w-1/2">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("setup.label.SubCategory") }}
                  <span class="required">*</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.SubCategory')"
                >
                  <v-select
                    label="subCategory"
                    :options="subCategoryItem"
                    :placeholder="$t('customers.label.SelectSubCategory')"
                    @input="onchangeSubCategory()"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="subCategory"
                    :reduce="(subCategory) => subCategory.id"
                    class="min-w-200 w-full mb-2"
                  />
                  <span class="validate-error text-danger">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col lg:w-1/2">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.QuestionText')"
              >
                <vs-input
                  :label="$t('setup.label.QuestionText')"
                  class="w-full mb-2"
                  v-model="questionText"
                />
                <span class="validate-error text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>

            <div class="vx-col w-full lg:w-1/4">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("setup.label.QuestionType") }}
                  <span class="required">*</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.QuestionType')"
                >
                  <v-select
                    v-model="questionType"
                    :options="questionTypeList"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="w-full"
                  />
                  <span class="validate-error text-danger">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-col w-full lg:w-1/4 mt-3">
              <vs-button
                @click="addQuestion"
                color="primary"
                type="filled"
                icon="icon-plus"
                icon-pack="feather"
              >
                Add Question
              </vs-button>
            </div>
          </div>

          <div v-if="questionType === 'CHECKBOX'" class="w-full mt-2">
            <div
              v-for="(option, index) in options"
              :key="index"
              class="vx-row mb-2 flex items-center"
            >
              <div class="vx-col w-full md:w-3/4 sm:w-full">
                <vs-input
                  v-model="option.value"
                  placeholder="Enter option"
                  class="w-full mb-2"
                />
              </div>
              <div class="vx-col w-full md:w-1/4 sm:w-full mt-2">
                <vs-button
                  color="danger"
                  icon-pack="feather"
                  icon="icon-trash-2"
                  class="rounded-2"
                  @click="removeOption(index)"
                >
                  {{ $t("setup.label.Remove") }}
                </vs-button>
              </div>
            </div>
            <div class="mt-4">
              <vs-button
                type="filled"
                color="primary"
                icon-pack="feather"
                icon="icon-plus"
                class="mb-2 rounded-2"
                @click="addOption"
              >
                {{ $t("Add Options") }}
              </vs-button>
            </div>
          </div>
        </vx-card>
      </div>

      <div v-if="subCategory" class="vx-row mt-2">
        <vx-card class="w-full">
          <vs-table
            :data="questionList"
            max-items="10"
            pagination
            stripe
            search
          >
            <template slot="header">
              <div class="list-heading">
                {{ $t("system.label.Questions") }}
              </div>
            </template>
            <template slot="thead">
              <vs-th class="tHeadCenter">{{$t("system.label.Id")}}</vs-th>
              <vs-th class="tHeadCenter">{{$t("system.label.QuestionType")}}</vs-th>
              <vs-th class="tHeadCenter">{{$t("system.label.QuestionText")}}</vs-th>
              <vs-th class="tHeadCenter">{{$t("system.label.Action")}}</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr v-for="(question, index) in data" :key="index">
                <vs-td
                  ><div class="container_img">{{ question.id }}</div></vs-td
                >
                <vs-td
                  ><div class="container_img">
                    {{ question.inputType }}
                  </div></vs-td
                >
                <vs-td
                  ><div class="container_img">
                    {{ question.questionText }}
                  </div></vs-td
                >
                <vs-td class="whitespace-no-wrap">
                  <div class="container_img">
                    <feather-icon
                      icon="EditIcon"
                      :title="$t('setup.label.Edit')"
                      svgClasses="w-5 h-5 stroke-current cursor orange_icon mr-2"
                      @click.stop="editQuestion(question.id)"
                      class="icon_row"
                    />
                    <feather-icon
                      icon="Trash2Icon"
                      :title="$t('setup.label.Delete')"
                      svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                      @click.stop="deleteQuestion(question.id)"
                      class="icon_row"
                    />
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>

      <!-- <div class="vx-row mt-6">
        <div class="vx-col w-full text-right">
          <vs-button color="primary" type="border" class="mr-2" @click="cancel">
            {{ $t("setup.label.Cancel") }}
          </vs-button>
          <vs-button color="success" @click="submitQuestions">
            {{ $t("setup.label.Submit") }}
          </vs-button>
        </div>
      </div> -->
    </ValidationObserver>
    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="$t('setup.label.EditQuestionSet')"
        :active.sync="editPopup"
        class="popup-close popup-width"
      >
        <vs-checkbox v-model="editForm.isActive" class="mb-3"
          >Is Active</vs-checkbox
        >
        <div class="vx-row">
          <div class="vx-col w-full lg:w-1/2">
            <div class="dropdown-with-label">
              <small class="date-label"
                >{{ $t("setup.label.Category") }}
                <span class="required">*</span></small
              >
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.Category')"
              >
                <v-select
                  label="mCodeValue"
                  :options="ticketTemplates.problemsDatas || []"
                  :placeholder="$t('customers.label.SelectCategory')"
                  :reduce="(mCodeValue) => mCodeValue.id"
                  disabled
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  v-model="editForm.category"
                  @input="getSubCategory"
                  class="min-w-200 w-full mb-2"
                >
                  <template v-slot:option="option">{{
                    option.mCodeValue
                  }}</template>
                </v-select>
                <span class="validate-error text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-col w-full lg:w-1/2">
            <div class="dropdown-with-label">
              <small class="date-label"
                >{{ $t("setup.label.SubCategory") }}
                <span class="required">*</span></small
              >
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.SubCategory')"
              >
                <v-select
                  label="subCategory"
                  :options="subCategoryItem"
                  disabled
                  :placeholder="$t('customers.label.SelectSubCategory')"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  v-model="editForm.subCategory"
                  :reduce="(subCategory) => subCategory.id"
                  class="min-w-200 w-full mb-2"
                />
                <span class="validate-error text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-col w-1/2">
            <vs-input
              label="Question Text"
              v-model="editForm.text"
              class="w-full mb-4"
            />
          </div>

          <div class="vx-col w-1/2">
            <div class="dropdown-with-label">
              <small class="date-label"
                >{{ $t("setup.label.QuestionType") }}
                <span class="required">*</span></small
              >
              <v-select
                v-model="editForm.type"
                :options="questionTypeList"
                placeholder="Select Question Type"
                class="w-full mb-4"
              />
            </div>
          </div>

          <div v-if="editForm.type === 'CHECKBOX'" class="w-full mx-4">
            <div
              v-for="(option, index) in editForm.options"
              :key="index"
              class="vx-row mb-2 items-center"
            >
              <div class="vx-col w-full md:w-3/4">
                <vs-input
                  v-model="option.value"
                  placeholder="Enter option"
                  class="w-full"
                />
              </div>
              <div class="vx-col w-full md:w-1/4 mt-5">
                <vs-button
                  color="danger"
                  type="filled"
                  icon="icon-trash-2"
                  icon-pack="feather"
                  @click="removeEditOption(index)"
                >
                  Remove
                </vs-button>
              </div>
            </div>
            <div>
              <vs-button
                type="filled"
                color="primary"
                icon="icon-plus"
                icon-pack="feather"
                class="mt-5"
                @click="addEditOption"
              >
                Add Option
              </vs-button>
            </div>
          </div>
        </div>

        <div class="flex justify-center mt-6">
          <vs-button @click="editPopup = false" type="border" class="mr-2"
            >Cancel</vs-button
          >
          <vs-button color="primary" @click="updateQuestion">Update</vs-button>
        </div>
      </vs-popup>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { mapState } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    "v-select": vSelect,
  },
  data() {
    return {
      category: "",
      subCategory: "",
      questionText: "",
      questionType: "",
      isSelfCare: false,
      options: [],
      questionTypeList: ["TEXT", "CHECKBOX", "YES_NO", "RATING"],

      editPopup: false,
      editForm: {
        text: "",
        type: "",
        options: [],
        category: "",
        subCategory: "",
        isActive: false,
      },
    };
  },
  computed: {
    ...mapState({
      ticketTemplates: (state) => state.entity.ticketTemplate,
      subCategoryItem: (state) => state.entity.ticketSubcategory,
      questionDetails: (state) => state.qna.questionDetails,
      questionList: (state) => state.qna.questionList,
    }),
  },
  watch: {
    isSelfCare(newVal) {
      if (this.subCategory) {
        this.getQuestionListByIdMethod(this.subCategory);
      }
    }
  },
  methods: {
    async onchangeSubCategory() {
      await this.getQuestionListByIdMethod(this.subCategory);
    },
    async editQuestion(id) {
      try {
        await this.$store.dispatch("qna/getQuestionDetailsAction", id);
      } catch (error) {
        this.$swal({
          title: "Error",
          icon: "error",
          text: "Something Went Wrong",
          type: "error",
        });
      }
      this.editForm = {
        id: this.questionDetails.id,
        text: this.questionDetails.questionText,
        isActive: this.questionDetails.isActive == "Y" ? true : false,
        type: this.questionDetails.inputType,
        options:
          (this.questionDetails.options &&
            this.questionDetails.options.map((opt) => ({ value: opt }))) ||
          [],
        subCategory: this.questionDetails.subcategoryId,
        category: this.questionDetails.categoryId,
      };
      this.editPopup = true;
    },
    async updateQuestion() {
      if (this.editForm.text && this.editForm.type) {
        const data = {
          questionText: this.editForm.text,
          inputType: this.editForm.type,
          subcategoryId: this.editForm.subCategory,
          categoryId: this.editForm.category,
          isActive: this.editForm.isActive ? "Y" : "N",
          inputValue:
            (this.editForm.options &&
              this.editForm.options.map((option) => option.value)) ||
            [],
        };
        const payload = {
          id: this.editForm.id,
          data: data,
        };
        try {
          await this.$store.dispatch("qna/editQuestionsAction", payload);
          this.$swal({
            title: "Success",
            icon: "success",
            text: "Question Successfully Updated",
            type: "success",
          });
          this.getQuestionListByIdMethod(this.editForm.subCategory);
        } catch (error) {
          this.$swal({
            title: "Error",
            icon: "error",
            text: "Something Went Wrong",
            type: "error",
          });
        }
        this.editPopup = false;
      }
    },

    addEditOption() {
      this.editForm.options.push({ value: "" });
    },

    removeEditOption(index) {
      this.editForm.options.splice(index, 1);
    },
    addOption() {
      this.options.push({ value: "" });
    },
    removeOption(index) {
      this.options.splice(index, 1);
    },
    async addQuestion() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      const payload = {
        questionText: this.questionText,
        inputType: this.questionType,
        subcategoryId: this.subCategory,
        categoryId: this.category,
        isselfcare: this.isSelfCare,
        inputValue:
          (this.options && this.options.map((option) => option.value)) || [],
      };
      try {
        await this.$store.dispatch("qna/createQuestionsAction", payload);
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Question Successfully Added",
          type: "success",
        });
        this.getQuestionListByIdMethod(this.subCategory);
      } catch (error) {
        this.$swal({
          title: "Error",
          icon: "error",
          text: error,
          type: "error",
        });
      }
      this.questionText = "";
      this.questionType = "";
      this.$refs.observer.reset();
      this.options = [];
    },
    async getQuestionListByIdMethod(id) {
      const payload={
        id: id,
        isSelfCare: this.isSelfCare
      }
      try {
        await this.$store.dispatch("qna/getQuestionListByIdAction", payload);
      } catch (error) {
        this.$swal({
          title: "Error",
          icon: "error",
          text: "Something Went Wrong",
          type: "error",
        });
      }
    },
    async deleteQuestion(id) {
      try {
        await this.$store.dispatch("qna/deleteQuestionAction", id);
        await this.getQuestionListByIdMethod(this.subCategory);
        this.$toasted.success("Question Deleted Successfully", {
          duration: 2000,
        });
      } catch (error) {
        this.$swal({
          title: "Error",
          icon: "error",
          text: "Something Went Wrong",
          type: "error",
        });
      }
    },
    cancel() {
      this.$router.push("/question-answer-set");
    },
    async getTicketTemplate() {
      try {
        await this.$store.dispatch("entity/setTicketTemplate");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getQuestionDetailsMethod(id) {
      try {
        await this.$store.dispatch("qna/getQuestionDetailsAction", id);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getSubCategory(categoryId) {
      this.subCategory = null;
      try {
        if (categoryId) {
          this.$store.dispatch("entity/setTicketSubcategory", categoryId);
        } else {
          this.$store.commit("entity/SET_TICKET_SUBCATEGORY", []);
          this.subCategory = null;
        }
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  async mounted() {
    await this.getTicketTemplate();
    this.category = Number(this.$route.params.category);
    this.getSubCategory(this.category);
    this.subCategory = Number(this.$route.params.subCategory);
    this.getQuestionListByIdMethod(this.subCategory);
  },
};
</script>

<style scoped>
.text-danger {
  color: red;
}
.vx-row {
  display: flex;
  flex-wrap: wrap;
}
</style>
<style>
.popup-width .vs-popup {
  width: 800px !important;
}
</style>
